import script from "./Carts.vue?vue&type=script&setup=true&lang=js"
export * from "./Carts.vue?vue&type=script&setup=true&lang=js"

import "./Carts.vue?vue&type=style&index=0&id=0679cb49&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0679cb49"]])

export default __exports__